type WithPrefix<T extends string, Prefix extends string> = T extends `${Prefix}${string}` ? T : never;

export const withPrefix = <Value extends string, Prefix extends string>(params: { value?: Value; prefix: Prefix }) =>
  params.value?.startsWith(params.prefix) ? (params.value as WithPrefix<Value, Prefix>) : undefined;
